import { IHttpResponse, IHttpStatus } from '@partners/api';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

type TResultCallback<T, R = void> = (data: T) => R;
type TStatusCallback = (status: IHttpStatus) => void;

export const tapResult = <T>(callback: TResultCallback<T>) => {
  return (response$: Observable<IHttpResponse<T>>): Observable<IHttpResponse<T>> => {
    return response$.pipe(
      tap((response: IHttpResponse<T>) => {
        const result: T = response.result as T;
        callback.call(null, result as T);
      })
    );
  };
};

export const filterResult = <R>() => {
  return (response$: Observable<IHttpResponse<R>>): Observable<R> => {
    return response$.pipe(
      catchError((error: any) => {
        return throwError(() => error);
      }),
      map((response: IHttpResponse<R>) => {
        return response.result as R;
      })
    );
  };
};

export function filterStatus<T>() {
  return (response$: Observable<IHttpResponse<T>>): Observable<IHttpStatus> => {
    return response$.pipe(
      catchError((error: any) => {
        return throwError(() => error);
      }),
      map((data: IHttpResponse<T>) => {
        return data.status;
      })
    );
  };
}

export const tapStatus = <T>(callback: TStatusCallback) => {
  return (response$: Observable<IHttpResponse<T>>): Observable<IHttpResponse<T>> => {
    return response$.pipe(
      tap((response: IHttpResponse<T>) => {
        callback.call(null, response.status as IHttpStatus);
      }),
      map((response: IHttpResponse<T>) => response)
    );
  };
};
